// extracted by mini-css-extract-plugin
module.exports = {"breadcrumb":"breadcrumb_breadcrumb_3SO0i","breadcrumbItem":"breadcrumb_breadcrumbItem_3Qzjv"};